import React from "react";
import { useHistory } from "react-router-dom";

import { useStateSelector } from "utils/field";
import { getEffectiveUserVerified } from "utils/user/verification";

import Tooltip from "components/Tooltip";

import classes from "./styles.module.scss";

import WarningIcon from "assets/images/icons/warning.svg";

const TOOLTIP_ID = "unverifiedUserTip";

const TOOLTIP_TEXT = `<span style="display:block;max-width:16rem;white-space:pre-line;">Your account is unverified.

Unverified accounts are limited to five models and cannot access Insights, Parametric Analysis, non-General simulations, or F280 reports.

Contact info@voltaresearch.org to request verification.</span>`;

const UnverifiedUserNotice = () => {
    const history = useHistory();
    const { createdAt = null, isUserVerified = false } = useStateSelector("user") || {};

    const isVerified = getEffectiveUserVerified({ createdAt, isUserVerified });
    if (isVerified) return null;

    return (
        <div className={classes.notice}>
            <button
                type="button"
                className={classes.badge}
                data-html
                data-tip={TOOLTIP_TEXT}
                data-for={TOOLTIP_ID}
                onClick={() => history.push("/user/account")}
                aria-label="Unverified account. View account status."
            >
                <img src={WarningIcon} alt="" className={classes.icon} />
                <span>Unverified Account</span>
            </button>
            <Tooltip id={TOOLTIP_ID} />
        </div>
    );
};

export default UnverifiedUserNotice;
